import { DoorsDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useDoors(searchParams?: string, enabled = true) {
  const url = `/v2/orm/door?${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<DoorsDTO>(request, {
    queryKey: ['doors', { searchParams }],
    enabled: enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useDoors;
